const baseKey = ['store'];
export const queryKeys = {
  seo: (storeId: string | number) => [...baseKey, 'seo', String(storeId)],
  store: (storeId: string | number) => [...baseKey, String(storeId)],
};

export const urls = {
  seo: (storeId: string | number) => `/stores/${storeId}/seo`,
  store: (storeId: string | number) => `/stores/${storeId}`,
};
